import { Box } from '@mui/material';

import { MainSidebar } from './MainSidebar';
import { SubSidebar } from './SubSidebar';
import type { NavItem, SubNavItem } from './types';
import { useSidebar } from './useSidebar';

interface AppSidebarProps {
  navItems: NavItem[];
  header: (isExpanded: boolean) => React.ReactNode;
  footer: (isExpanded: boolean) => React.ReactNode;
  activeItemId?: string;
  activeSubMenuTitle?: string;
  activeSubItems?: SubNavItem[];
  childrenVariant?: 'panel' | 'tree';
}

export const AppSidebar: React.FC<AppSidebarProps> = ({
  navItems,
  header,
  footer,
  activeItemId,
  activeSubMenuTitle,
  childrenVariant = 'panel',
  activeSubItems,
}) => {
  const { state, toggle, variant, isCollapsible } = useSidebar();

  return (
    <>
      {variant === 'overlay' && state !== 'hidden' ? (
        <Box
          onClick={toggle}
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(4px)',
            zIndex: 1100, // Below sidebar (1200)
          }}
        />
      ) : null}
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          ...(variant === 'overlay' && {
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            zIndex: 1200,
            width: 'auto',
          }),
        }}
      >
        <MainSidebar
          header={header}
          footer={footer}
          items={navItems}
          state={state}
          onToggle={toggle}
          activeItemId={activeItemId}
          childrenVariant={childrenVariant}
          variant={variant}
          isCollapsible={isCollapsible}
        />
        {activeSubMenuTitle && activeSubItems && state !== 'hidden' && (
          <SubSidebar title={activeSubMenuTitle} items={activeSubItems} />
        )}
      </Box>
    </>
  );
};
